import {
  loadAndMigrateState,
  Migrator,
  migrateProduktForVorteilsrabatt,
  migrateProduktnameToEnum,
  migrateZahlungsoptionen,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { migrateSelbstbeteiligung } from './1_migrate_selbstbeteiligung';
import { migrateKooperationsNachlass } from './4_migrate_kooperations-nachlass';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 1,
    migratorFunction: migrateSelbstbeteiligung,
  },
  {
    toVersion: 2,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 3,
    migratorFunction: migrateProduktnameToEnum,
  },
  {
    toVersion: 4,
    migratorFunction: migrateKooperationsNachlass,
  },
  {
    toVersion: 5,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 6,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 7,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
];

export const loadAndMigrateUnfState = (
  currentState: IAppState,
  loadedState: { version: number },
  beibehalten?: boolean,
) => loadAndMigrateState(currentState, loadedState, stateMigrators, beibehalten);
